import { z } from 'zod';

export const UserId = z
  .string()
  .regex(/^[0-9A-F]{28,36}$/, 'Invalid Healthcare user id');

// eslint-disable-next-line no-redeclare
export type UserId = z.infer<typeof UserId>;
